<template>
	<div v-if="$route.name!='order'" class="order">
		<div class="header">
			<el-menu router :default-active="$route.name" mode="horizontal">
				<el-menu-item index="order_dispatch" :route="{name:'order_dispatch'}">订单调度</el-menu-item>
				<el-submenu index="order_list">
					<template slot="title">订单列表</template>
					<el-menu-item index="order_list_all" :route="{name:'order_list_all'}">全部订单</el-menu-item>
					<el-menu-item index="order_list_arrive" :route="{name:'order_list_arrive'}">已到达</el-menu-item>
					<el-menu-item index="order_list_service" :route="{name:'order_list_service'}">服务中</el-menu-item>
					<el-menu-item index="order_list_pay" :route="{name:'order_list_pay'}">待支付</el-menu-item>
					<el-menu-item index="order_list_complete" :route="{name:'order_list_complete'}">已完成</el-menu-item>
					<el-menu-item index="order_list_cancel" :route="{name:'order_list_cancel'}">已取消</el-menu-item>
				</el-submenu>
				<el-menu-item index="order_comment" :route="{name:'order_comment'}">订单评价</el-menu-item>
				<el-menu-item index="order_pay" :route="{name:'order_pay'}">支付记录</el-menu-item>
			</el-menu>
		</div>
		<router-view ref="orderCallback"></router-view>
	</div>
</template>

<script>
	export default {
		created() {
			this.resetRoute();
		},
		methods: {
			resetRoute(){
				const that = this;
				if (that.$route.name == 'order') {
					that.$router.push({
						name: 'order_dispatch'
					});
				}
			},
			postDispatch(){
				this.$refs.orderCallback.postDispatch();
			}
		},
		watch: {
			$route: {
				handler: 'resetRoute'
			}
		}
	}
</script>
